var deviceType;

import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";
import { buildProductCard, buildVendorCard } from "../helpers/cardComponents";
import Util from "../helpers/util";
import CartObject from "../helpers/cartUtil";
const UtilObject = new Util();

//Loading and using Google maps helper functions
import GoogleMapsApi from "../helpers/GoogleMapsApi";
var GoogleMapsApiObjectVendor = new GoogleMapsApi();

export default class CustomerSearch {
  constructor() {
    this.searchDebounceTimer = null;
    this.lastQuery = "";
    this.minQueryLength = 2;
    this.activeDeviceType = 1;
    this.bindEvents();
    this.fetchPopularCategories();
    this.fetchRecentSearches();
    this.bindEvents();
  }

  getActiveInput = () => {
    return $(".searchBar").first();
  };

  getQueryValue = () => {
    return this.getActiveInput().val().trim();
  };

  setLoadingState = (isLoading) => {
    $(".vendor-loading, .products-loading").toggleClass("d-none", !isLoading);
    if (isLoading) {
      $(".search-results-state").removeClass("d-none");
      $(".search-pre-state").addClass("d-none");
    }
  };

  clearResults = () => {
    $("div.vendorSearchResults").empty();
    $("div.productServiceSearchResults").empty();
    $(".no-search-sellers").addClass("d-none");
    $(".no-search-products").addClass("d-none");
  };

  toggleClearButton = () => {
    const hasInput = this.getQueryValue().length > 0;
    $(".locaso-search-clear-btn").toggleClass("d-none", !hasInput);
  };

  scheduleSearch = () => {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => {
      this.SearchResults();
    }, 320);
  };

  bindEvents = () => {
    $(".searchBarBtnMain").on("click", this.SearchResults);

    $(".locaso-search-clear-btn").on("click", () => {
      this.getActiveInput().val("");
      this.toggleClearButton();
      this.clearResults();
      $("#customerSearchError").html("");
      this.lastQuery = "";
      $(".search-results-state").addClass("d-none");
      $(".search-pre-state").removeClass("d-none");
    });

    $(".textareaDesktop").on("input", () => {
      this.toggleClearButton();
      const query = this.getQueryValue();
      if (!query) {
        this.clearResults();
        $(".search-results-state").addClass("d-none");
        $(".search-pre-state").removeClass("d-none");
        this.lastQuery = "";
      } else {
        if (query.length >= this.minQueryLength) {
          $(".search-pre-state").addClass("d-none");
          $(".search-results-state").removeClass("d-none");
          this.scheduleSearch();
        }
      }
    });

    $(".searchBarBtn").on("keyup", (event) => {
      if (event.which === 13) {
        this.SearchResults();
      }
    });

    $(document).on("click", ".addToCartBtn", this.addItemInCart);
  };

  addItemInCart = async (event) => {
    const pID = String(event.currentTarget.value || "").trim();
    const vID = String($(event.currentTarget).data("vendor") || "").trim();
    const $btn = $(event.currentTarget);

    if (!pID || !vID) return;

    const originalText = $btn.text();
    $btn.prop("disabled", true).text("ADDING...");

    // Force real-time check
    const currentCart = await CartObject.cartCheck();
    const vendorFromOrder = currentCart.vendor;

    if (vendorFromOrder != null && currentCart.Products.length > 0) {
      if (vendorFromOrder.Vendor_ID != vID) {
        // Ensure modal exists in DOM
        this.ensureVendorSwitchModal();
        const modal = bootstrap.Modal.getOrCreateInstance("#showCartModal");
        
        // Custom cleanup for this specific click
        $("#showCartModal .startNewCart").off("click.search").on("click.search", async () => {
          modal.hide();
          await this.deleteEntireCart();
          await this.addtoCart({ Product_ID: pID, Quantity: 1, Vendor_ID: vID }, "ADD");
          $btn.text("ADDED").prop("disabled", true);
          UtilObject.showToast("Item added to cart!", "success");
        });

        modal.show();
        $btn.prop("disabled", false).text(originalText);
        return;
      }
    }

    await this.addtoCart({ Product_ID: pID, Quantity: 1, Vendor_ID: vID }, "ADD");
    $btn.text("ADDED").prop("disabled", true);
    UtilObject.showToast("Item added to cart!", "success");
    CartObject.notifyCartUpdate();
  };

  addtoCart = (product, type) => {
    return new Promise((resolve) => {
      $.ajax({
        url: globalThis.baseURL + "api/customer/Cart/AddtoCart",
        type: "POST",
        data: {
          Vendor_ID: product.Vendor_ID,
          Product_ID: product.Product_ID,
          Quantity: product.Quantity,
          Type: type,
        },
        headers: { Authorization: globalThis.X_API_KEY },
        success: (result) => {
          resolve(result);
        },
        error: (err) => {
          resolve(null);
        },
      });
    });
  };

  deleteEntireCart = () => {
    return new Promise((resolve) => {
      const CartDetails = UtilObject.getAllCookies();
      $.ajax({
        url: globalThis.baseURL + "api/customer/Cart/DeleteCart",
        type: "POST",
        data: {
          Order_ID: CartDetails["ORDER_ID"],
        },
        headers: { Authorization: globalThis.X_API_KEY },
        success: (result) => {
          CartObject.notifyCartUpdate();
          resolve(true);
        },
        error: (err) => {
          resolve(false);
        },
      });
    });
  };

  ensureVendorSwitchModal = () => {
    if ($("#showCartModal").length) {
      return;
    }
    const modalHtml = `
      <div class="modal fade" id="showCartModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 shadow-lg">
            <div class="modal-header bg-light">
              <h5 class="modal-title fw-bold">Switch Vendor?</h5>
            </div>
            <div class="modal-body py-4">
              <p class="mb-0">You already have items from another vendor in your cart. Do you want to clear current cart and add this item?</p>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light rounded-pill px-4 keepOldCart" data-bs-dismiss="modal">Keep Old Cart</button>
              <button type="button" class="btn text-white rounded-pill px-4 startNewCart" style="background: #ff385c;">Yes, Start Fresh</button>
            </div>
          </div>
        </div>
      </div>
    `;
    $("body").append(modalHtml);
  };

  fetchPopularCategories = () => {
    const $container = $(".popular-categories-grid");
    $.ajax({
      url: globalThis.baseURL + "api/customer/Homepage/getCategoryType",
      type: "GET",
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        $container.empty();
        if (result && result.length > 0) {
          result.forEach((cat) => {
            const img = getImageUrl(cat.Icon_Url);
            const item = `
              <div class="category-pill-item" onclick="window.location.href='${globalThis.baseURL}customer/vendorListingPage/${cat.Picklist_display_value}'">
                <div class="category-img-wrap">
                  <img src="${img}" alt="${cat.Picklist_display_value}" onerror="this.src='${globalThis.baseURL}assets/src/images/no-image.png'">
                </div>
                <div class="category-name">${cat.Picklist_display_value}</div>
              </div>`;
            $container.append(item);
          });
        } else {
          $container.html(
            '<p class="text-muted small">No categories found</p>',
          );
        }
      },
      error: () => {
        $container.html(
          '<p class="text-muted small">Failed to load categories</p>',
        );
      },
    });
  };

  fetchRecentSearches = () => {
    $.ajax({
      url: globalThis.baseURL + "api/customer/Search/SearchOptions",
      type: "GET",
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        const $container = $(".recentSearchesDesktop");
        $container.empty();
        if (result && result.length > 0) {
          $(".recent-searches-block").removeClass("d-none");
          result.forEach((element) => {
            const item = `
              <div class="recent-pill">
                <i class="fa-solid fa-clock-rotate-left"></i>
                <span>${element.Search_Name}</span>
              </div>`;
            const $pill = $(item);
            $pill.on("click", () => {
              $(".searchBar").val(element.Search_Name);
              this.SearchResults();
            });
            $container.append($pill);
          });
        } else {
          $(".recent-searches-block").addClass("d-none");
        }
      },
    });
  };

  SearchResults = () => {
    const input = this.getQueryValue();
    if (!input || input.length < this.minQueryLength) {
      if (input.length > 0) {
        $("#customerSearchError").html(
          `Type at least ${this.minQueryLength} characters`,
        );
      } else {
        $("#customerSearchError").html("");
      }
      this.clearResults();
      return;
    }

    if (this.lastQuery.toLowerCase() === input.toLowerCase()) {
      return;
    }

    this.lastQuery = input;
    $("#customerSearchError").html("");
    this.setLoadingState(true);

    $.ajax({
      url:
        baseURL +
        "api/customer/Search/SearchVendorOrProductWithMultipleCategories",
      type: "POST",
      data: { Search_Name: input },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        this.setLoadingState(false);
        this.showSearchResults(result);
      },
      error: () => {
        this.setLoadingState(false);
        $("#customerSearchError").html("Unable to fetch results. Try again.");
      },
    });
  };

  showSearchResults = (results) => {
    const $vendorContainer = $("div.vendorSearchResults");
    const $productContainer = $("div.productServiceSearchResults");

    $vendorContainer.empty();
    $productContainer.empty();

    const vendors = results.Vendors || [];
    const products = results.Products || [];

    // 1. Render Vendors (Sellers Tab)
    if (vendors.length > 0) {
      $(".no-search-sellers").addClass("d-none");
      const $row = $('<div class="row g-3"></div>');
      vendors.forEach((v) => {
        const card = buildVendorCard(v, { isCarousel: false });
        $row.append(card);
      });
      $vendorContainer.append($row);
    } else {
      $(".no-search-sellers").removeClass("d-none");
    }

    // 2. Render Products (Dishes Tab)
    if (products.length > 0) {
      $(".no-search-products").addClass("d-none");

      // Group by vendor
      const grouped = {};
      products.forEach((p) => {
        const vName = p.Business_Name || p.Vendor_Name;
        if (!grouped[vName])
          grouped[vName] = {
            info: { name: vName, url: p.Vendor_URL },
            items: [],
          };
        grouped[vName].items.push(p);
      });

      Object.values(grouped).forEach((group) => {
        const vendorHeader = `
          <div class="locaso-search-vendor-head d-flex justify-content-between align-items-center mb-3 mt-5 px-1 border-bottom pb-2">
            <div>
              <p class="text-muted small mb-0 fw-600" style="font-size: 0.5rem">From</p>
              <h5 class="fw-700 mb-0" style="font-size: 0.8rem;">${group.info.name}</h5>
            </div>
            <a href="${globalThis.baseURL}customer/productListing/${group.info.url}" class="locaso-view-menu-btn text-decoration-none shadow-sm">View Store</a>
          </div>`;
        $productContainer.append(vendorHeader);

        const $row = $('<div class="row g-3"></div>');
        group.items.forEach((p) => {
          const card = buildProductCard(p, { isCarousel: false });
          $row.append(card);
        });
        $productContainer.append($row);
      });
    } else {
      $(".no-search-products").removeClass("d-none");
    }
  };
}
